export enum ProfileTabEnum {
  profile = 'profil',
  teamManagement = 'gestion-equipe',
  subscriptionManagement = 'gestion-de-mon-abonnement',
  myAccount = 'gestion-de-mon-compte',
}
